import { axiosbaseurl } from 'configure';
import React, { useEffect, useMemo, useState } from 'react'
import ReactApexChart from 'react-apexcharts';

const UtrCacPayeVat = () => {

    const [datas, setdatas] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getDatas = async () => {
            try {
                setLoading(true)
                const response = await axiosbaseurl.get("/reports/utr-cac-paye-vat/count");
                setdatas([
                    {
                        name: "UTR",
                        pending: response.data?.data?.UTRNumberPending || "",
                        received: response.data?.data?.haveUTRNumber || ""
                    },
                    {
                        name: "CAC",
                        pending: response.data?.data?.CACNumberPending || "",
                        received: response.data?.data?.haveCACNumber || ""
                    },
                    {
                        name: "PAYE",
                        pending: response.data?.data?.PAYENumberPending || "",
                        received: response.data?.data?.havePAYENumber || ""
                    },
                    {
                        name: "VAT",
                        pending: response.data?.data?.VATNumberPending || "",
                        received: response.data?.data?.haveVATNumber || ""
                    }
                ])
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        getDatas()
    }, [])

    const graph_props = useMemo(() => (
        {

            series: [
                {
                    name: 'Pending',
                    data: datas.map(s => s.pending)
                },
                {
                    name: 'Received',
                    data: datas.map(s => s.received)
                }
            ],
            options: {
                chart: {
                    type: 'bar',
                    height: 450,
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '40%',
                        borderRadius: 5,
                        borderRadiusApplication: 'end'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["#fff"],
                },
                xaxis: {
                    labels: {
                        rotate: -52
                    },
                    categories: datas.map(s => s.name),
                },
                yaxis: {
                    title: {
                        text: 'No. of clients'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Clients"
                        }
                    }
                },
                colors: ['#dd4949', '#40a676']
            },


        }
    ), [datas])


    return (
        <div>
            <div>
                <h5 className='text-dark fw-semibold'>UTR CAC PAYE VAT</h5>
            </div>

            <div className='mb-5'>
                <div>
                    <div id="chart ">
                        <ReactApexChart options={graph_props?.options || []} series={graph_props?.series || []} type="bar" height={350} />
                    </div>
                    <div id="html-dist"></div>
                </div>
            </div>
            <div className='mt-5'>
                <table className='table table-bordered'>
                    <thead className='table-primary'>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Pending Clients</th>
                            <th>Received Clients</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            datas.map((item, i) => (
                                <tr key={item.name}>
                                    <td>{i + 1}</td>
                                    <td>{item.name}</td>
                                    <td>{item.pending > 10 ? item.pending : `0${item.pending}`}</td>
                                    <td>{item.received > 10 ? item.received : `0${item.received}`}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default UtrCacPayeVat